export function isSolicitacoesRoute(route) {
    if (!route) return false;

    const path = route.path || '';
    if (path.startsWith('/solicitacoes')) return true;

    return route.matched?.some((record) => record.name === 'Solicitacoes') ?? false;
}
